import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { authorization } from 'Module/Auth/Auth'
import { Modal } from 'Components/Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ButtonDelete } from 'Components/Buttons/ButtonDelete'
import { ButtonEdit } from 'Components/Buttons/ButtonEdit'
import { ButtonWithText } from 'Components/Buttons/ButtonWithText'
import { MISSION_STATUS_ENUM } from './../../../../shared/constants'
import { ActionLinksWrapper } from './style'
import SubmitButton from 'Components/Form/SubmitButton'

const DeleteMissionModal = ({ show, handleCancel, handleConfirm }) => (
  <Modal show={show}>
    <ModalHeader>
      <ModalTitle>Delete Mission</ModalTitle>
    </ModalHeader>
    <ModalBody />
    <ModalFooter>
      <SubmitButton value="cancel" onClick={handleCancel} />
      <SubmitButton value="Confirm" onClick={handleConfirm} />
    </ModalFooter>
  </Modal>
)

class ActionLinks extends Component {
  state = { showModalConfirmation: false }

  canEdit = ({ mission } = this.props) =>
    mission.status !== MISSION_STATUS_ENUM.PAID && !authorization.isClient()
  canDelete = ({ mission } = this.props) =>
    [MISSION_STATUS_ENUM.DRAFT, MISSION_STATUS_ENUM.AVAILABLE].indexOf(
      mission.status,
    ) !== -1 && !authorization.isClient()

  canUnbook = ({ mission } = this.props) =>
    mission.status === MISSION_STATUS_ENUM.BOOKED

  canCancel = ({ mission } = this.props) =>
    [
      MISSION_STATUS_ENUM.CHECKED_IN,
      MISSION_STATUS_ENUM.UNDER_REVIEW,
      MISSION_STATUS_ENUM.COMPLETED,
    ].indexOf(mission.status) !== -1 && !authorization.isClient()

  closeModal = () => this.setState({ showModalConfirmation: false })
  openModal = () => this.setState({ showModalConfirmation: true })

  openUnbookModal = () => {
    const cancel = this.canCancel()
    const title = cancel ? 'Cancel Mission' : 'Unbook Mission'
    const text = this.props.mission.canBeSpied ? (
      cancel ? (
        <span
          style={{
            color: 'red',
          }}
        >
          The mission would be removed from the spy shift if you cancel mission
        </span>
      ) : (
        <span
          style={{
            color: 'red',
          }}
        >
          The mission would be removed from the spy shift if you unbook mission
        </span>
      )
    ) : null
    this.props.showUnbookModal({ title, cancel, text })
  }

  editAction = () => {
    const { history, match } = this.props
    history.push(`${match.url}/edit`.replace(/\/+/gi, '/'))
  }

  handleConfirmDelete = () => {
    const { deleteAction, mission } = this.props

    deleteAction(mission.id)
    this.closeModal()
  }

  render() {
    const { deleteAction, editMode } = this.props
    const { showModalConfirmation } = this.state
    if (
      !(authorization.isCityManager() || authorization.isClient()) ||
      editMode
    )
      return null

    return (
      <ActionLinksWrapper>
        {this.canEdit() && (
          <ButtonEdit float="left" onClickHandler={this.editAction} />
        )}
        {(this.canUnbook() || this.canCancel()) && (
          <ButtonWithText
            className="unbook-button"
            label={this.canCancel() ? 'Cancel Mission' : 'Unbook'}
            onClickHandler={this.openUnbookModal}
          />
        )}
        {deleteAction && this.canDelete() && (
          <ButtonDelete float="left" onClickHandler={this.openModal} />
        )}
        <DeleteMissionModal
          show={showModalConfirmation}
          handleCancel={this.closeModal}
          handleConfirm={this.handleConfirmDelete}
        />
      </ActionLinksWrapper>
    )
  }
}

ActionLinks.propTypes = {
  mission: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  deleteAction: PropTypes.func,
  editMode: PropTypes.bool,
}

ActionLinks.defaultProps = {
  deleteAction: null,
  editMode: false,
}

export { ActionLinks }



// WEBPACK FOOTER //
// ./src/Containers/Mission/Header/ActionLinks/index.js